import { render, staticRenderFns } from "./SwitchToMentorProfileModal.vue?vue&type=template&id=6e4aa676&"
import script from "./SwitchToMentorProfileModal.vue?vue&type=script&lang=js&"
export * from "./SwitchToMentorProfileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports